import React from 'react'

import { Dropdown } from 'components/shared/Dropdown/Dropdown'
import ArrowDown from 'assets/icons/arrow-down.svg'
import styles from './LanguageSwitchAnchor.module.scss'
import cx from 'classnames'

export const LanguageSwitchAnchor = ({ icon, original, dark }) => (
  <Dropdown.Anchor className={styles.anchor}>
    <img className={styles.flag} src={icon} alt={original} />
    <span
      className={cx(styles.name, {
        [styles.dark]: dark,
      })}
    >
      {original}
    </span>
    <img
      className={cx(styles.arrow, {
        [styles.dark]: dark,
      })}
      src={ArrowDown}
      alt={original}
    />
  </Dropdown.Anchor>
)
